import React from 'react'
import { Page, PageError, PageRedirectResponse } from '@moonpig/web-core-app'
import { Routes } from '@moonpig/web-core-routing'
import { FavouritesProvider } from '@moonpig/web-shared-products'
import { useFlag } from '@moonpig/web-explore-flags'
import { SearchPage } from './SearchPage'

type SearchPageProps = React.ComponentProps<typeof SearchPage>
export type SearchSwitchingPageProps = SearchPageProps

export const SearchSwitchingPage: Page<
  SearchSwitchingPageProps,
  Routes['search']
> = initialProps => {
  return (
    <FavouritesProvider
      location={initialProps.pageTitle}
      enableToastNotification={useFlag('enable-fav-toast-notification')}
    >
      <div data-testid="search-page">
        <SearchPage {...(initialProps as SearchPageProps)} />
      </div>
    </FavouritesProvider>
  )
}

type GetInitialPropsReturn =
  | SearchSwitchingPageProps
  | {
      pageError: PageError
    }

SearchSwitchingPage.layout = 'default'

SearchSwitchingPage.getInitialProps = async (
  context,
): Promise<PageRedirectResponse | GetInitialPropsReturn> => {
  const searchPageInitPropsResponse = await SearchPage.getInitialProps(context)

  if (searchPageInitPropsResponse.pageRedirect) {
    return {
      pageRedirect: searchPageInitPropsResponse.pageRedirect,
    }
  }

  return searchPageInitPropsResponse
}
